import { Col, Row } from 'antd';
import React from 'react';
import SectionHeader from '../SectionHeader/SectionHeader';
import CategoryCard from './CategoryCard';

function CategoryGrid({
  sectionHeading,
  headerLink,
  headerDescription,
  responsive,
  data = []
}) {
  return (
    <section className={`category-grid ${responsive ? 'responsive-view' : ''}`}>
      <div className="container">
        <SectionHeader
          heading={sectionHeading}
          headerLink={headerLink}
          headerDescription={headerDescription}
        />
        <Row
          gutter={[
            { xs: 8, sm: 8, md: responsive ? 8 : 16, lg: responsive ? 8 : 16 },
            { xs: 8, sm: 8, md: responsive ? 8 : 16, lg: responsive ? 8 : 16 }
          ]}
        >
          {data?.map((item) => {
            return (
              <Col
                key={item?.id}
                xs={{ span: responsive ? 12 : 12 }}
                md={{ span: responsive ? 12 : 8 }}
                lg={{ span: responsive ? 12 : 6 }}
                xxl={{ span: responsive ? 12 : 6 }}
              >
                <CategoryCard
                  grid
                  href={item?.href}
                  topic={item?.topic}
                  backgroundColor={item?.backgroundColor}
                  textColor={item?.textColor}
                />
              </Col>
            );
          })}
        </Row>
      </div>
    </section>
  );
}
export default CategoryGrid;
